import React from 'react';
import { useUserActions } from 'shared/auth/hooks/useUserActions';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface FeedbackSupportProps {
  label: string;
  reportId: number;
  questionId: number;
  className?: string;
}

const FeedbackSupport: React.FC<FeedbackSupportProps> = ({
  reportId,
  questionId,
  label,
  className,
}) => {
  const { email } = useUserActions();
  return (
    <TrueImpactText
      className={className}
      onClick={() => {
        const subject = `Feedback Question - Report id ${reportId}`;
        const body = `User email: ${email} - Question id: ${questionId}\n\n\n`;
        window.open(
          `mailto:support@trueimpact.com?subject=${encodeURIComponent(
            subject,
          )}&body=${encodeURIComponent(body)}`,
        );
      }}
    >
      {label}
    </TrueImpactText>
  );
};

export default FeedbackSupport;
